/**
 * The help centre's chrome. The articles themselves — headings, titles and
 * bodies — live in helpContent.tsx, which carries a tree per language.
 */
const en = {
  title: 'Help & documentation',
  subtitle: 'Everything from installing the SDK to running ReplayOps on your own infrastructure.',
  onThisPage: 'On this page',
  searchPlaceholder: 'Search help…  (try “minio”, “403”, “retention”, “alerts”)',
  noMatch: (q: string) => `No help articles match “${q}”.`,
  stuck: 'Still stuck?',
  stuckBody: 'Check the deployment posture and audit log, or reach the team.',
  openSecurity: 'Open Security',
  integrationsHub: 'Integrations Hub',
  configuration: 'Configuration',
};

const tr: typeof en = {
  title: 'Yardım ve dokümantasyon',
  subtitle:
    'SDK kurulumundan ReplayOps’u kendi altyapınızda çalıştırmaya kadar her şey.',
  onThisPage: 'Bu sayfada',
  searchPlaceholder: 'Yardımda ara…  (örn. “minio”, “403”, “saklama”, “uyarı”)',
  noMatch: (q: string) => `“${q}” ile eşleşen yardım makalesi yok.`,
  stuck: 'Hâlâ takıldınız mı?',
  stuckBody: 'Kurulum durumuna ve denetim kaydına bakın ya da ekibe ulaşın.',
  openSecurity: 'Güvenlik’i aç',
  integrationsHub: 'Entegrasyon Merkezi',
  configuration: 'Yapılandırma',
};

export const help = { en, tr };
